import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import AccessGroupApi from '../server/AccessGroupApi';
import Handlers from '../dispatcher/Handlers';

export default {
    getAll: (params) => {
        const types = {
            success: ActionTypes.ACCESS_GROUP_LIST,
            failure: ActionTypes.ACCESS_GROUP_LIST_ERROR
        };
        return CentricDispatcher.dispatchAsync(AccessGroupApi.getAll(params), types, {params});
    },

    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ACCESS_GROUP_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleFormError = Handlers.createFormErrorHandler(ActionTypes.ACCESS_GROUP_INFO_ERROR);

        return AccessGroupApi.save(entity)
            .then(handleSuccess, handleFormError)
            .catch(Handlers._handleException);
    },

    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ACCESS_GROUP_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleFormError = Handlers.createFormErrorHandler(ActionTypes.ACCESS_GROUP_UPDATE_ERROR);

        return AccessGroupApi.update(id, entity)
            .then(handleSuccess, handleFormError)
            .catch(Handlers._handleException);
    },

    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ACCESS_GROUP_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.ACCESS_GROUP_DELETE_ERROR);

        return AccessGroupApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

};
